/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateTndAccount = /* GraphQL */ `
  subscription OnCreateTndAccount {
    onCreateTndAccount {
      id
      enabled
      location
      description
      loginId
      loginPassword
      apiKey
      users
    }
  }
`;
export const onUpdateTndAccount = /* GraphQL */ `
  subscription OnUpdateTndAccount {
    onUpdateTndAccount {
      id
      enabled
      location
      description
      loginId
      loginPassword
      apiKey
      users
    }
  }
`;
export const onDeleteTndAccount = /* GraphQL */ `
  subscription OnDeleteTndAccount {
    onDeleteTndAccount {
      id
      enabled
      location
      description
      loginId
      loginPassword
      apiKey
      users
    }
  }
`;
export const onCreateSensorName = /* GraphQL */ `
  subscription OnCreateSensorName {
    onCreateSensorName {
      serial
      name
      ch1
      ch2
    }
  }
`;
export const onUpdateSensorName = /* GraphQL */ `
  subscription OnUpdateSensorName {
    onUpdateSensorName {
      serial
      name
      ch1
      ch2
    }
  }
`;
export const onDeleteSensorName = /* GraphQL */ `
  subscription OnDeleteSensorName {
    onDeleteSensorName {
      serial
      name
      ch1
      ch2
    }
  }
`;
export const onCreateSensorDayReading = /* GraphQL */ `
  subscription OnCreateSensorDayReading {
    onCreateSensorDayReading {
      serial
      localDate
      tndAccountLoginId
      name
      utcOffsetMinutes
      readings {
        dataId
        unixtime
        reading
      }
      channel2Name
      channel2Readings {
        dataId
        unixtime
        reading
      }
    }
  }
`;
export const onUpdateSensorDayReading = /* GraphQL */ `
  subscription OnUpdateSensorDayReading {
    onUpdateSensorDayReading {
      serial
      localDate
      tndAccountLoginId
      name
      utcOffsetMinutes
      readings {
        dataId
        unixtime
        reading
      }
      channel2Name
      channel2Readings {
        dataId
        unixtime
        reading
      }
    }
  }
`;
export const onDeleteSensorDayReading = /* GraphQL */ `
  subscription OnDeleteSensorDayReading {
    onDeleteSensorDayReading {
      serial
      localDate
      tndAccountLoginId
      name
      utcOffsetMinutes
      readings {
        dataId
        unixtime
        reading
      }
      channel2Name
      channel2Readings {
        dataId
        unixtime
        reading
      }
    }
  }
`;
export const onCreateLastSensorUnixTime = /* GraphQL */ `
  subscription OnCreateLastSensorUnixTime {
    onCreateLastSensorUnixTime {
      serial
      unixtime
      name
      tndAccountLoginId
      lastCheckUnixtime
    }
  }
`;
export const onUpdateLastSensorUnixTime = /* GraphQL */ `
  subscription OnUpdateLastSensorUnixTime {
    onUpdateLastSensorUnixTime {
      serial
      unixtime
      name
      tndAccountLoginId
      lastCheckUnixtime
    }
  }
`;
export const onDeleteLastSensorUnixTime = /* GraphQL */ `
  subscription OnDeleteLastSensorUnixTime {
    onDeleteLastSensorUnixTime {
      serial
      unixtime
      name
      tndAccountLoginId
      lastCheckUnixtime
    }
  }
`;
export const onCreateSensorCheckoutControl = /* GraphQL */ `
  subscription OnCreateSensorCheckoutControl {
    onCreateSensorCheckoutControl {
      serial
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const onUpdateSensorCheckoutControl = /* GraphQL */ `
  subscription OnUpdateSensorCheckoutControl {
    onUpdateSensorCheckoutControl {
      serial
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const onDeleteSensorCheckoutControl = /* GraphQL */ `
  subscription OnDeleteSensorCheckoutControl {
    onDeleteSensorCheckoutControl {
      serial
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const onCreateSensorCheckoutRecord = /* GraphQL */ `
  subscription OnCreateSensorCheckoutRecord {
    onCreateSensorCheckoutRecord {
      serial
      localDate
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const onUpdateSensorCheckoutRecord = /* GraphQL */ `
  subscription OnUpdateSensorCheckoutRecord {
    onUpdateSensorCheckoutRecord {
      serial
      localDate
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const onDeleteSensorCheckoutRecord = /* GraphQL */ `
  subscription OnDeleteSensorCheckoutRecord {
    onDeleteSensorCheckoutRecord {
      serial
      localDate
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser {
    onCreateUser {
      username
      email
      name
      city
      company
      department
      post
      phone
      privileges
      tndAccountLoginIds
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser {
    onUpdateUser {
      username
      email
      name
      city
      company
      department
      post
      phone
      privileges
      tndAccountLoginIds
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser {
    onDeleteUser {
      username
      email
      name
      city
      company
      department
      post
      phone
      privileges
      tndAccountLoginIds
    }
  }
`;
